import React from 'react'

import { IconProps } from 'types/icon.type'

export const GiftIcon: React.FC<IconProps> = ({
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      {...attributes}
    >
      <title>iDEAL icon</title>
      <mask
        id="mask0_2_138"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="37"
        height="37"
      >
        <rect x="0.5" y="0.573975" width="36" height="36" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2_138)">
        <path
          d="M6.97323 29.8123V16.1968H6.82885C6.2711 16.1968 5.80185 16.0042 5.4211 15.619C5.04035 15.2335 4.84998 14.765 4.84998 14.2135V11.2491C4.84998 10.6978 5.04223 10.2318 5.42673 9.85108C5.81123 9.47033 6.2786 9.27995 6.82885 9.27995H11.7069C11.4954 8.9857 11.3391 8.66146 11.2381 8.30721C11.1371 7.95296 11.0866 7.58096 11.0866 7.19121C11.0866 6.06946 11.4792 5.11596 12.2645 4.33071C13.0497 3.54546 14.0032 3.15283 15.125 3.15283C15.7822 3.15283 16.3917 3.30471 16.9535 3.60846C17.5152 3.91246 18.0019 4.31633 18.4134 4.82008C18.7999 4.32583 19.2821 3.92446 19.8601 3.61596C20.4379 3.30721 21.0517 3.15283 21.7017 3.15283C22.8237 3.15283 23.7774 3.54546 24.5626 4.33071C25.3479 5.11596 25.7405 6.06946 25.7405 7.19121C25.7405 7.54896 25.6799 7.90908 25.5586 8.27158C25.4374 8.63408 25.2912 8.97021 25.1202 9.27995H30.1711C30.7214 9.27995 31.1887 9.47258 31.5732 9.85783C31.9577 10.2433 32.15 10.7118 32.15 11.2633V14.2277C32.15 14.779 31.9577 15.245 31.5732 15.6257C31.1887 16.0065 30.7214 16.1968 30.1711 16.1968H30.0267V29.8123C30.0267 30.4756 29.7906 31.0433 29.3184 31.5156C28.8461 31.9878 28.2785 32.224 27.6155 32.224H9.38448C8.72148 32.224 8.15385 31.9878 7.6816 31.5156C7.20935 31.0433 6.97323 30.4756 6.97323 29.8123ZM21.7017 5.10283C21.11 5.10283 20.614 5.30296 20.2137 5.70321C19.8135 6.10346 19.6134 6.59946 19.6134 7.19121C19.6134 7.78296 19.8135 8.27896 20.2137 8.67921C20.614 9.07971 21.11 9.27995 21.7017 9.27995C22.2935 9.27995 22.7896 9.07971 23.1901 8.67921C23.5904 8.27896 23.7905 7.78296 23.7905 7.19121C23.7905 6.59946 23.5904 6.10346 23.1901 5.70321C22.7896 5.30296 22.2935 5.10283 21.7017 5.10283ZM13.0366 7.19121C13.0366 7.78296 13.2367 8.27896 13.637 8.67921C14.0372 9.07971 14.5332 9.27995 15.125 9.27995C15.7167 9.27995 16.2127 9.07971 16.613 8.67921C17.0132 8.27896 17.2134 7.78296 17.2134 7.19121C17.2134 6.59946 17.0132 6.10346 16.613 5.70321C16.2127 5.30296 15.7167 5.10283 15.125 5.10283C14.5332 5.10283 14.0372 5.30296 13.637 5.70321C13.2367 6.10346 13.0366 6.59946 13.0366 7.19121ZM6.79998 11.2296V14.2472H17.525V11.2296H6.79998ZM17.525 30.274V16.1968H8.92285V29.8123C8.92285 29.9471 8.96623 30.0577 9.05298 30.1442C9.13948 30.2307 9.24998 30.274 9.38448 30.274H17.525ZM19.475 30.274H27.6155C27.75 30.274 27.8605 30.2307 27.947 30.1442C28.0337 30.0577 28.0771 29.9471 28.0771 29.8123V16.1968H19.475V30.274ZM30.2 14.2472V11.2296H19.475V14.2472H30.2Z"
          fill="#1C1B1F"
        />
      </g>{' '}
    </svg>
  )
}
